import { domToPng } from 'modern-screenshot';

import {
  BLANK_IMAGE,
  CAPTURE_TIMEOUT_MS,
  PIXEL_RATIO,
  fetchImage,
  saveDataUrl,
  withTimeout,
} from './downloadEmailPng';

/**
 * Draws an element on the page as it is shown, at twice its size, and
 * downloads it as a PNG. Unlike an email, it needs no copy: it is plain
 * same-origin DOM, such as a text message phone. Its images (a campaign
 * text's tile photo) are fetched again to draw, as an email's are.
 *
 * @param {object} options
 * @param {HTMLElement} options.element
 * @param {string} options.fileName
 * @returns {Promise<void>}
 */
export const downloadElementPng = async ({ element, fileName }) => {
  const png = await withTimeout(
    domToPng(element, {
      scale: PIXEL_RATIO,
      fetch: { placeholderImage: BLANK_IMAGE },
      fetchFn: fetchImage,
    }),
    CAPTURE_TIMEOUT_MS,
  );

  saveDataUrl(png, fileName);
};
